<template>
  <b-container fluid>
    <b-row no-gutters class="bordered-box-header align-items-center">
      <h2>Raporty</h2>
    </b-row>
    <b-row no-gutters class="bordered-box">
      <lectorsItem />
    </b-row>
    <b-row no-gutters class="bordered-box">
      <studentLessonsItem />
    </b-row>
    <b-row no-gutters class="bordered-box">
      <studentExerciseItem />
    </b-row>
  </b-container>
</template>

<script>
import lectorsItem from "./ReportsLectorsItem";
import studentLessonsItem from "./ReportsStudentLessonsItem";
import studentExerciseItem from "./ReportsStudentExercisesItem";

export default {
  components: {
    lectorsItem,
    studentLessonsItem,
    studentExerciseItem
  },
  data() {
    return {
      loading: true
    };
  }
};
</script>

<style lang="scss" scoped>
.bordered-box-header {
  margin-top: 20px;
  padding: 10px;
  margin-bottom: 0px;
  background: rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.bordered-box {
  border: 1px solid rgba(0, 0, 0, 0.125);
  padding: 10px;
}
</style>